import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { CityReservationModel, PagedList, StoreProductModel } from '../interface';
import { ProductInfoType, SortType, StoreProductResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxStoreProductService {

  constructor(private api: StoreProductResourceService) {
  }

  getStoreProductList(params?: {
    ids?: number[],
    page?: number,
    limit?: number,
    orderBy?: string,
    sort?: SortType,
    query?: string,
    storeId?: number,
    types?: ProductInfoType[],
    cfOutputProduct?: boolean,
    purchasable?: boolean,
    categoryId?: number
  }): Observable<PagedList<StoreProductModel>> {
    return this.api.get(
      params?.categoryId, params?.cfOutputProduct, params?.ids, params?.limit,
      params?.orderBy, params?.page, params?.purchasable, params?.query,
      params?.sort, params?.storeId, params?.types
    ) as unknown as Observable<PagedList<StoreProductModel>>;
  }

  getStoreProduct(productId: number): Observable<StoreProductModel> {
    return this.api.getStoreProductById(productId) as unknown as Observable<StoreProductModel>;
  }

  getStoreProductGroupedByStoreId(productInfoId: number): Observable<CityReservationModel[]> {
    return this.api.getGroupedByStoreWithReservations(productInfoId) as unknown as Observable<CityReservationModel[]>;
  }

  saveStoreProduct(request: SaveProductRequest): Promise<void> {
    return firstValueFrom(this.api.saveStoreProduct(request as any));
  }

  syncStoreProduct(req: {productInfoId: number, storeId: number}): Observable<void> {
    return this.api.syncStoreProduct(req as any);
  }

  getBalance(params: {
    storeId?: number,
    categoryIds?: number[],
    productInfoTitle?: string,
    productInfoTypes?: ProductInfoType[]
  }): Observable<StoreProductModel[]> {
    return this.api.getAllByStore(params?.categoryIds, params?.productInfoTitle, params?.productInfoTypes, params?.storeId) as unknown as Observable<StoreProductModel[]>;
  }
}

export interface SaveProductRequest {
  id: number;
  productInfoId: number;
  storeId: number;
  organizationId: number;
  amount: number;
  forSale: boolean;
  onlineSellable: boolean;
  minOrderDay: number;
  untilOrderTime: string;
  receiveAfterTime: string;
}
